import script from "./tfun.vue?vue&type=script&lang=js"
export * from "./tfun.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__